"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable quotes, quote-props, comma-dangle */

/**
 * This file is regenerated by generate-api-constants.js
 * Do not edit it manually.
 * Last generated Tue Mar 26 2019 15:45:23 GMT+0800 (+08)
 **/

var MSA_SEARCH_HASHES = exports.MSA_SEARCH_HASHES = {
  "new-york": "5ShV8xd7Y6s-new-york-fitness-classes",
  "los-angeles": "5TAvjLvJsr7-los-angeles-orange-county-fitness-classes",
  "san-francisco": "3xkpSNmbtXR-san-francisco-fitness-classes",
  "chicago": "43G5uaPvTEX-chicago-fitness-classes",
  "miami": "3qDTLb6b2UX-miami-south-florida-fitness-classes",
  "boston": "4JgAszB7xYF-boston-fitness-classes",
  "washington-dc": "66eEJwG3Pmq-washington-dc-fitness-classes",
  "seattle": "46qXbWAMrpf-seattle-fitness-classes",
  "atlanta": "5HJEMZhESGF-atlanta-fitness-classes",
  "austin": "5PabyCxg9Zy-austin-fitness-classes",
  "charlotte": "5st8GhRHdWX-charlotte-fitness-classes",
  "columbus": "4EAPJSxZJi3-columbus-fitness-classes",
  "dallas": "3mNN23Z7DFu-dallas-fort-worth-fitness-classes",
  "denver": "4RGynQWxXHZ-denver-boulder-fitness-classes",
  "houston": "5b2fdKfuPmq-houston-fitness-classes",
  "minneapolis": "4C8K8FVBcKq-minneapolis-st-paul-fitness-classes",
  "philadelphia": "3ywvjgVqNLX-philadelphia-fitness-classes",
  "phoenix": "65r1WyaWp3R-phoenix-scottsdale-fitness-classes",
  "portland": "5sba8Ldjbro-portland-fitness-classes",
  "san-diego": "4HgK3UQ3tCw-san-diego-fitness-classes",
  "las-vegas": "4JsqPxXtgDM-las-vegas-fitness-classes",
  "raleigh": "4vHhrQSCfWo-raleigh-fitness-classes",
  "baltimore": "4NzVSkCp9fV-baltimore-fitness-classes",
  "tampa": "5S7YXReM2eB-tampa-fitness-classes",
  "st-louis": "5egTrZYfy9q-st-louis-fitness-classes",
  "orlando": "5x5CVwMGtqV-orlando-fitness-classes",
  "nashville": "6BCvLLSxkWT-nashville-fitness-classes",
  "sacramento": "4sadcs5YTKm-sacramento-fitness-classes",
  "kansas-city": "4Mbih6JVUYX-kansas-city-fitness-classes",
  "cincinnati": "4nt18Gwsw5q-cincinnati-fitness-classes",
  "pittsburgh": "4ob9KgkKkjH-pittsburgh-fitness-classes",
  "milwaukee": "45zicPvMK19-milwaukee-fitness-classes",
  "london": "5toZe65BG47-london-fitness-classes",
  "toronto": "4t8yphpqcgF-toronto-fitness-classes",
  "vancouver": "5GyCuQbvmGb-vancouver-fitness-classes",
  "sydney": "5wHCfXMwmFu-sydney-fitness-classes",
  "melbourne": "68iXacRMn55-melbourne-fitness-classes",
  "brisbane": "4QA3wpv8JFh-brisbane-fitness-classes",
  "perth": "68cXekCDLaj-perth-fitness-classes",
  "adelaide": "5nwcXu13Wco-adelaide-fitness-classes",
  "new-orleans": "4wcuqSrzvzB-new-orleans-fitness-classes",
  "san-antonio": "4Dj2idzwWjh-san-antonio-fitness-classes",
  "indianapolis": "4EL1eUQPUYo-indianapolis-fitness-classes",
  "salt-lake-city": "65bDk6NWw8T-salt-lake-city-fitness-classes",
  "honolulu": "4xsuWJ6p135-honolulu-fitness-classes",
  "calgary": "663AJH9QBWo-calgary-fitness-classes",
  "inland-empire": "3sHjVsdrxco-inland-empire-fitness-classes",
  "missoula": "5wjMDN8gK91-missoula-fitness-classes",
  "manchester": "4Ky1ZBSMaVM-manchester-fitness-classes",
  "bristol": "3jAqVd1VfDH-bristol-fitness-classes",
  "singapore": "3sVQDn8S6dm-singapore-fitness-classes",
  "united-states": "4RV5H8xJKcK-united-states-fitness-classes",
  "united-kingdom": "6DoTyxa7FWP-united-kingdom-fitness-classes",
  "australia": "4D7FrvGtZQ3-australia-fitness-classes",
  "hong-kong": "4g6M6kssdbm-hong-kong-fitness-classes",
  "united-arab-emirates": "4NsP6ke9e1V-united-arab-emirates-fitness-classes",
  "new-zealand": "3jJGYTntcNB-new-zealand-fitness-classes",
  "thailand": "4VXCWJ66uUT-thailand-fitness-classes",
  "malaysia": "42HqNuFeYAs-malaysia-fitness-classes"
};